import { render, staticRenderFns } from "./OrganizationalStructureTypeView.vue?vue&type=template&id=8c3f4de8"
import script from "./OrganizationalStructureTypeView.vue?vue&type=script&lang=js"
export * from "./OrganizationalStructureTypeView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports